<template>
    <div v-if="isLoaded">
        <div class="modal" tabindex="-1" role="dialog">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header p-2" style="height:64px">
                        <h5 class="modal-title">{{requestInfo.m_req_id}} | {{requestInfo.file_info[0].file_name}} | created by : {{requestInfo.requestor_name}}</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close" v-on:click="closeMetadataManager">
                            <span aria-hidden="true">
                                <cancel-icon class="close-icon" style="height: 40px !important;
                                    width: 40px !important;
                                    color: #fff;">
                                </cancel-icon>
                            </span>
                        </button>
                    </div>
                    <div class="modal-body row">
                        <div v-if="!isTypeCatalog" class="col-md-6 selected-thumbnail-display h-100 p-1 m-0" style="overflow-y:auto;">
                            <div class="w-100" style="height:45%;display:flex;justify-content:center">
                                <template v-if="isVideoFile">
                                    <div style="height:100%;width:100%;display:inline-block">
                                        <video-player id="video-player-id" @controller="setController" :options="videoOptions" style="height:100%;width:100%"/>
                                    </div>
                                </template>
                                <audio v-if="isAudioFile" id="audio-player-id" class="audio-player" controls="controls" controlslist="nodownload">
                                    <source :src="audioUrl" type="audio/mpeg" />
                                </audio>
                                <!-- <embed v-if="!isVideoFile" src="http://www.pdf995.com/samples/pdf.pdf" alt="pdf" style="height:100%;width:100%" pluginspage="http://www.adobe.com/products/acrobat/readstep2.html"> -->
                                <img v-if="isImageFile" :src="getThumbnailPath(assetDetails)" @error="replaceByDefaultImage" style="max-width: 100% !important;max-height: 100% !important;border-radius: 7px !important;object-fit: contain; !important">
                            </div>
                            <div class="assets-details-in-metadata-manager">
                                <ul>
                                    <li>
                                        <div class="key-style">{{$t('Filename')}} : </div>
                                        <div class="value-style" style="overflow-wrap:anywhere">{{getFileName(assetDetails)}}</div>
                                    </li>
                                    <li v-if="startUpInfo.enable_reference_id_workflow && Object.keys(assetDetails).includes('reference_id') &&
                                        !['undefined',null].includes(assetDetails.reference_id) &&  assetDetails.reference_id.length > 0">
                                        <div class="key-style">{{startUpInfo.alias &&  startUpInfo.alias.alias_name?startUpInfo.alias.alias_name:"Reference ID"}}</div>
                                        <div class="value-style">{{assetDetails.reference_id}}</div>
                                    </li>
                                    <li>
                                        <div class="key-style">{{$t('Path')}} : </div>
                                        <div class="value-style" style="overflow-wrap:anywhere">{{getFilePath(assetDetails)}}</div>
                                    </li>

                                    <li v-if="assetDetails.storage_class && assetDetails.storage_class.length > 0">
                                        <div class="key-style">{{$t('Location')}}</div>
                                        <div class="value-style">
                                            <div v-for="storageClass in assetDetails.storage_class" class="d-inline-flex" :key="storageClass">
                                                <svg v-if='storageClass == "Disk"' xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#35b2cf" class="bi bi-archive-fill" viewBox="0 0 16 16" style="margin-top:2px !important">
                                                    <path d="M12.643 15C13.979 15 15 13.845 15 12.5V5H1v7.5C1 13.845 2.021 15 3.357 15h9.286zM5.5 7h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1 0-1zM.8 1a.8.8 0 0 0-.8.8V3a.8.8 0 0 0 .8.8h14.4A.8.8 0 0 0 16 3V1.8a.8.8 0 0 0-.8-.8H.8z"></path>
                                                    <title>{{$t('Archived')}}</title>
                                                </svg>
                                                <svg v-else xmlns="http://www.w3.org/2000/svg" width="16" height="16" :fill="getColorBasedOnExpiry(assetDetails.location_info,storageClass)" class="bi bi-cloud-fill storage-type-icon" viewBox="0 0 16 16" style="margin-top:2px !important">
                                                    <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383z"/>
                                                </svg>
                                                <span style="margin-inline-start:4px">{{ storageClass }}</span>
                                            </div>
                                        </div>
                                    </li>
                                    <!-- <li>
                                        <div class="key-style">Date Added</div>
                                        <div class="value-style">{{assetDetails.added_datetime}}</div>
                                    </li>
                                    <li>
                                        <div class="key-style">Date Created</div>
                                        <div class="value-style">{{assetDetails.created_datetime}}</div>
                                    </li> -->
                                    <li>
                                        <div class="key-style">Size : </div>
                                        <div class="value-style">{{humaniseSize(assetDetails.size)}}</div>
                                    </li>
                                    <li>
                                        <div class="key-style">Request status : </div>
                                        <div class="value-style" style="text-transform:capitalize;">{{requestInfo.status}}</div>
                                    </li>
                                    <!-- <li v-if="(assetDetails.mime_type.startsWith('video') && 'duration' in assetDetails)">
                                        <div class="key-style">Duration</div>
                                        <div class="value-style">02:12</div>
                                    </li> -->
                                </ul>
                            </div>
                        </div>
                        <div class="p-0 h-100 metadata-fields" :class="isTypeCatalog?'col-md-14':'col-md-8'" style="display:flex">
                            <div  style="margin-inline-end: 1px;margin-inline-start: 1px;width: 100%;">
                                <ul class="metadata-dock-ul align-texts">
                                    <li>
                                        <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;"
                                                        >
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <span class="slug-ellipsis" style="font-size: 18px;">
                                                            {{$t('Current Metadata')}}
                                                        </span>
                                                    </div>
                                                </div>
                                        </div>
                                        <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;"
                                                        >
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <span class="slug-ellipsis" style="font-size: 18px;">
                                                            {{$t('Proposed changes')}} 
                                                        </span>
                                                    </div>
                                                </div>
                                        </div>
                                    </li>
                                    <li v-if="newMetadataInfo.filter(op=>op.key_id=='slug_name').length > 0">
                                        <div class="existing-metadata">
                                            <div style="display:flex">
                                                <div class="key-style">{{$t('Media Slug')}}</div>
                                                <span style="color:#858585"> *</span>
                                            </div>
                                            <div class="value-style d-inline-flex">
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <span v-if="existingMetadataInfo.filter(op=>op.key_id == 'slug_name').length > 0"
                                                             class="slug-ellipsis" :title="existingMetadataInfo.filter(op=>op.key_id == 'slug_name')[0].value">
                                                            {{ existingMetadataInfo.filter(op=>op.key_id == 'slug_name')[0].value }}
                                                        </span>
                                                        <span v-else class="slug-ellipsis"></span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="newMetadataInfo.filter(op=>op.key_id=='slug_name').length > 0"
                                             class="existing-metadata" style="margin-inline-start: 11px;" :class="(!existingMetadataInfo.filter(op=>op.key_id == 'slug_name').length ||[undefined,null].includes(existingMetadataInfo.filter(op=>op.key_id == 'slug_name')[0].value) || !existingMetadataInfo.filter(op=>op.key_id == 'slug_name')[0].value.trim().length)
                                                                     ? 'added-value':
                                                                       (!newMetadataInfo.filter(op=>op.key_id=='slug_name')[0].value.trim().length
                                                                            ?'cleared-value':'updated-value')">
                                            <div style="display:flex">
                                                <div class="key-style">{{$t('Media Slug')}}</div>
                                                <span style="color:#858585"> *</span>
                                            </div>
                                            <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;"
                                                        >
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <span class="slug-ellipsis" :title="newMetadataInfo.filter(op=>op.key_id=='slug_name')[0].value">
                                                            {{newMetadataInfo.filter(op=>op.key_id=='slug_name')[0].value }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="newMetadataInfo.filter(op=>op.key_id=='catalog').length > 0">
                                        <div class="existing-metadata">
                                            <div class="key-style">{{$t('Catalogs')}}</div>
                                            <div class="value-style d-inline-flex">
                                                <div class="w-100">
                                                    <div class="d-inline-flex">
                                                        <ul v-if="existingMetadataInfo.filter(op=>op.key_id == 'catalog').length > 0" class="tags-display-ul p-0" style="display:inline-flex">
                                                            <template v-for="opt in existingMetadataInfo.filter(op=>op.key_id == 'catalog')[0].catalog_info">
                                                                <div v-bind:key = opt.catalog_id_path>
                                                                    <li class="view-tags" :title='opt.catalog_name_path'>
                                                                        <label>{{ opt.catalog_name_path }}</label>
                                                                    </li>
                                                                </div>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="newMetadataInfo.filter(op=>op.key_id=='catalog').length > 0"
                                             class="existing-metadata" style="margin-inline-start: 11px;" :class="(!existingMetadataInfo.filter(op=>op.key_id == 'catalog').length || [undefined,null].includes(existingMetadataInfo.filter(op=>op.key_id == 'catalog')[0].value) || !existingMetadataInfo.filter(op=>op.key_id == 'catalog')[0].value.length)
                                                                     ? 'added-value':
                                                                       (!newMetadataInfo.filter(op=>op.key_id=='catalog')[0].value.length
                                                                            ?'cleared-value':'updated-value')">
                                            <div style="display:flex">
                                                <div class="key-style">{{$t('Catalogs')}}</div>
                                            </div>
                                            <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;">
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <ul v-if="newMetadataInfo.filter(op=>op.key_id == 'catalog').length > 0" class="tags-display-ul p-0" style="display:inline-flex">
                                                            <template v-for="opt in newMetadataInfo.filter(op=>op.key_id == 'catalog')[0].catalog_info">
                                                                <div v-bind:key = opt.catalog_id_path>
                                                                    <li class="view-tags" :title='opt.catalog_name_path'>
                                                                        <label>{{ opt.catalog_name_path }}</label>
                                                                    </li>
                                                                </div>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="newMetadataInfo.filter(op=>op.key_id=='description').length > 0">
                                        <div class="existing-metadata desc-div">
                                            <div style="display:flex">
                                                <div class="key-style">{{$t('Description')}}</div>
                                            </div>
                                            <div class="value-style d-inline-flex">
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <textarea :readonly="true" v-if="existingMetadataInfo.filter(op=>op.key_id == 'description').length > 0"
                                                             class="desc-ellipsis"
                                                             :value="existingMetadataInfo.filter(op=>op.key_id == 'description')[0].value"
                                                             :title="existingMetadataInfo.filter(op=>op.key_id == 'description')[0].value">
                                                        </textarea>
                                                        <textarea :readonly="true" v-else class="desc-ellipsis"
                                                        value=""></textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="newMetadataInfo.filter(op=>op.key_id=='description').length > 0"
                                             class="existing-metadata desc-div" style="margin-inline-start: 11px;"
                                              :class="(!existingMetadataInfo.filter(op=>op.key_id == 'description').length || [undefined,null].includes(existingMetadataInfo.filter(op=>op.key_id == 'description')[0].value) || !existingMetadataInfo.filter(op=>op.key_id == 'description')[0].value.trim().length)
                                                                     ? 'added-value':
                                                                       (!newMetadataInfo.filter(op=>op.key_id=='description')[0].value.trim().length
                                                                            ?'cleared-value':'updated-value')">
                                            <div style="display:flex">
                                                <div class="key-style">{{$t('Description')}}</div>
                                            </div>
                                            <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;"
                                                        >
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <textarea :readonly="true" class="desc-ellipsis"
                                                        :value="newMetadataInfo.filter(op=>op.key_id=='description')[0].value"
                                                        :title="newMetadataInfo.filter(op=>op.key_id=='description')[0].value">
                                                        </textarea>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li v-if="newMetadataInfo.filter(op=>op.key_id=='tag').length > 0">
                                        <div class="existing-metadata">
                                            <div class="key-style">{{$t('Tags')}}</div>
                                            <div class="value-style d-inline-flex">
                                                <div class="w-100">
                                                    <div class="d-inline-flex">
                                                        <ul v-if="existingMetadataInfo.filter(op=>op.key_id == 'tag').length > 0" class="tags-display-ul p-0" style="display:inline-flex">
                                                            <template v-for="opt in existingMetadataInfo.filter(op=>op.key_id == 'tag')[0].tag_info">
                                                                <div v-bind:key = opt.tag_id>
                                                                    <li class="view-tags" :title='opt.name'>
                                                                        <label>{{ opt.name }}</label>
                                                                    </li>
                                                                </div>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="newMetadataInfo.filter(op=>op.key_id=='tag').length > 0"
                                             class="existing-metadata" style="margin-inline-start: 11px;" :class="(!existingMetadataInfo.filter(op=>op.key_id == 'tag').length || [undefined,null].includes(existingMetadataInfo.filter(op=>op.key_id == 'tag')[0].value) || !existingMetadataInfo.filter(op=>op.key_id == 'tag')[0].value.length)
                                                                     ? 'added-value':
                                                                       (!newMetadataInfo.filter(op=>op.key_id=='tag')[0].value.length
                                                                            ?'cleared-value':'updated-value')">
                                            <div style="display:flex">
                                                <div class="key-style">{{$t('Tags')}}</div>
                                            </div>
                                            <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;">
                                                <div class="w-100">
                                                    <div class="d-inline-flex w-100">
                                                        <ul v-if="newMetadataInfo.filter(op=>op.key_id == 'tag').length > 0" class="tags-display-ul p-0" style="display:inline-flex">
                                                            <template v-for="opt in newMetadataInfo.filter(op=>op.key_id == 'tag')[0].tag_info">
                                                                <div v-bind:key = opt.tag_id>
                                                                    <li class="view-tags" :title='opt.name'>
                                                                        <label>{{ opt.name }}</label>
                                                                    </li>
                                                                </div>
                                                            </template>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <template v-for="fieldId of sScreenFields.field_id_list">
                                        <template v-if="newMetadataInfo.filter(op=>op.key_id==fieldId).length > 0">
                                            <li v-if="['FREETEXT','FREETEXT_MULTILINE','INTEGER','DATE','DATE_TIME'].includes(getFieldType(fieldId))" :key="fieldId">
                                                <div class="existing-metadata">
                                                    <div style="display:flex">
                                                        <div class="key-style">{{getFieldName(fieldId)}}</div>
                                                        <span style="color:#858585" v-if="sScreenFields.mandatory_field_id_list.includes(fieldId)"> *</span>
                                                    </div>
                                                    <div class="value-style d-inline-flex">
                                                        <div class="w-100">
                                                            <div class="d-inline-flex w-100">
                                                                <span v-if="existingMetadataInfo.filter(op=>op.key_id == fieldId).length > 0" class="slug-ellipsis"
                                                                    :title="existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value.join(',')">
                                                                    {{ existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value.join(',') }}
                                                                </span>
                                                                <span v-else class="slug-ellipsis"></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="newMetadataInfo.filter(op=>op.key_id==fieldId).length > 0"
                                                    class="existing-metadata" style="margin-inline-start: 11px;" :class="(!existingMetadataInfo.filter(op=>op.key_id == fieldId).length ||[undefined,null].includes(existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value) || !existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value.length)
                                                                            ? 'added-value':
                                                                            (!newMetadataInfo.filter(op=>op.key_id==fieldId)[0].value.length
                                                                                    ?'cleared-value':'updated-value')">
                                                    <div style="display:flex">
                                                        <div class="key-style">{{getFieldName(fieldId)}}</div>
                                                        <span style="color:#858585" v-if="sScreenFields.mandatory_field_id_list.includes(fieldId)"> *</span>
                                                    </div>
                                                    <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;">
                                                        <div class="w-100">
                                                            <div class="d-inline-flex w-100">
                                                                <span class="slug-ellipsis" :title="newMetadataInfo.filter(op=>op.key_id==fieldId)[0].value.join(',')">
                                                                    {{newMetadataInfo.filter(op=>op.key_id==fieldId)[0].value.join(',') }}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li v-if="['PICKLIST'].includes(getFieldType(fieldId))" :key="fieldId">
                                                <div class="existing-metadata">
                                                    <div style="display:flex">
                                                        <div class="key-style">{{getFieldName(fieldId)}}</div>
                                                        <span style="color:#858585" v-if="sScreenFields.mandatory_field_id_list.includes(fieldId)"> *</span>
                                                    </div>
                                                    <div class="value-style d-inline-flex">
                                                        <div class="w-100">
                                                            <div class="d-inline-flex w-100">
                                                                <span v-if="existingMetadataInfo.filter(op=>op.key_id == fieldId).length && existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].field_info.length">
                                                                    {{existingMetadataInfo.filter(op=>op.key_id == fieldId)[0]["field_info"][0].value}}
                                                                </span>
                                                                <span v-else></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="newMetadataInfo.filter(op=>op.key_id==fieldId).length > 0"
                                                    class="existing-metadata" style="margin-inline-start: 11px;" :class="(!existingMetadataInfo.filter(op=>op.key_id == fieldId).length ||[undefined,null].includes(existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value) || !existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value.length)
                                                                            ? 'added-value':
                                                                            (!newMetadataInfo.filter(op=>op.key_id==fieldId)[0].value.length
                                                                                    ?'cleared-value':'updated-value')">
                                                    <div style="display:flex">
                                                        <div class="key-style">{{getFieldName(fieldId)}}</div>
                                                        <span style="color:#858585" v-if="sScreenFields.mandatory_field_id_list.includes(fieldId)"> *</span>
                                                    </div>
                                                    <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;">
                                                        <div class="w-100">
                                                            <div class="d-inline-flex w-100">
                                                                <span v-if="newMetadataInfo.filter(op=>op.key_id == fieldId).length && newMetadataInfo.filter(op=>op.key_id == fieldId)[0].field_info.length">
                                                                    {{newMetadataInfo.filter(op=>op.key_id == fieldId)[0]["field_info"][0].value}}
                                                                </span>
                                                                <span v-else></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                            <li v-if="['PICKLIST_MULTIVALUE'].includes(getFieldType(fieldId))" :key="fieldId">
                                                <div class="existing-metadata">
                                                    <div style="display:flex">
                                                        <div class="key-style">{{getFieldName(fieldId)}}</div>
                                                        <span style="color:#858585" v-if="sScreenFields.mandatory_field_id_list.includes(fieldId)"> *</span>
                                                    </div>
                                                    <div class="value-style d-inline-flex">
                                                        <div class="w-100">
                                                            <div class="d-inline-flex w-100">
                                                                <ul v-if="existingMetadataInfo.filter(op=>op.key_id == fieldId).length > 0" class="tags-display-ul p-0" style="display:inline-flex">
                                                                    <template v-for="opt in existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].field_info">
                                                                        <div v-bind:key = opt.value_id>
                                                                            <li class="view-tags" :title='opt.value'>
                                                                                <label>{{ opt.value }}</label>
                                                                            </li>
                                                                        </div>
                                                                    </template>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="newMetadataInfo.filter(op=>op.key_id==fieldId).length > 0"
                                                    class="existing-metadata" style="margin-inline-start: 11px;" :class="(!existingMetadataInfo.filter(op=>op.key_id == fieldId).length ||[undefined,null].includes(existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value) || !existingMetadataInfo.filter(op=>op.key_id == fieldId)[0].value.length)
                                                                            ? 'added-value':
                                                                            (!newMetadataInfo.filter(op=>op.key_id==fieldId)[0].value.length
                                                                                    ?'cleared-value':'updated-value')">
                                                    <div style="display:flex">
                                                        <div class="key-style">{{getFieldName(fieldId)}}</div>
                                                        <span style="color:#858585" v-if="sScreenFields.mandatory_field_id_list.includes(fieldId)"> *</span>
                                                    </div>
                                                    <div class="value-style d-inline-flex" style="margin-inline-start: 6px !important;">
                                                        <div class="w-100">
                                                            <div class="d-inline-flex w-100">
                                                                <ul v-if="newMetadataInfo.filter(op=>op.key_id == fieldId).length > 0" class="tags-display-ul p-0" style="display:inline-flex">
                                                                    <template v-for="opt in newMetadataInfo.filter(op=>op.key_id == fieldId)[0].field_info">
                                                                        <div v-bind:key = opt.value_id>
                                                                            <li class="view-tags" :title='opt.value'>
                                                                                <label>{{ opt.value }}</label>
                                                                            </li>
                                                                        </div>
                                                                    </template>
                                                                </ul>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </li>
                                        </template>
                                    </template>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer p-0 primary-btn-style">
                        <div style="width: 80%;display: flex;align-items: center;margin-inline-start: 10px;">
                            <div style="padding-inline-end: 13px;">
                                <svg xmlns="http://www.w3.org/2000/svg"  width="16" height="16" fill="#237d21" class="bi bi-square-fill" viewBox="0 0 16 16">
                                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"/>
                                </svg> Added</div>
                            <div style="padding-inline-end: 13px;">
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="#5a83af" class="bi bi-square-fill" viewBox="0 0 16 16">
                                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"/>
                                </svg> Updated</div>
                            <div style="padding-inline-end: 13px;">
                                <svg xmlns="http://www.w3.org/2000/svg"  width="16" height="16" fill="#a10505" class="bi bi-square-fill" viewBox="0 0 16 16">
                                    <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z"/>
                                </svg> Deleted</div>
                        </div>
                        <div v-if="requestInfo.status=='open' && isActionEnabled('tag-metadata-approver')" style="width:20%;display:flex;align-items: center;justify-content: end;">
                            <button class="btn btn-outline-danger" v-if="requestInfo.status == 'open'" style="border: 1px solid #831515;margin-inline-end:10px" data-dismiss="modal" @click="reject()">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path fill-rule="evenodd" d="M13.854 2.146a.5.5 0 0 1 0 .708l-11 11a.5.5 0 0 1-.708-.708l11-11a.5.5 0 0 1 .708 0Z"/>
                                    <path fill-rule="evenodd" d="M2.146 2.146a.5.5 0 0 0 0 .708l11 11a.5.5 0 0 0 .708-.708l-11-11a.5.5 0 0 0-.708 0Z"/>
                                </svg>Reject
                            </button>
                            <button class="btn btn-outline-primary" @click='approve()' style="margin-inline-end:10px">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                    <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z"/>
                                </svg>Approve
                            </button>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <NewCommentComp v-if="openCommentComponent" @close="openCommentComponent=!openCommentComponent" @handleAddButtonClick="rejectWithComments"></NewCommentComp>
    </div>
</template>

<script>
import CancelIcon from "../core/InlineCancelField.vue";
import VideoPlayer from "../core/VideoPlayer.vue";
import "vue2-datepicker/index.css";
import {mapActions, mapGetters,mapMutations} from "vuex";
import Utils from "../../components.utils.js"
import RangeSliderMixins from '../../mixins/RangeSliderMixin.js';
import {NotifierConstants} from "../../components.constants.js";
import NewCommentComp from "../actions/Comment.vue"

export default {
    mixins:[RangeSliderMixins],
    props:["requestId"],
    data() {
        return {
        openCommentComponent:false,
        sScreenFields:{},
        tagMetadataScreenId:"",
        sCMList:[],
        isLoaded:false,
        assetId:null,
        time:null,
        requestInfo:{},
        newMetadataInfo:[],
        existingMetadataInfo:[],
        assetDetails:{},
        route:"",
        editingMetadataKeyInDock:null,
        assetCustomMetadata : {"custom_metadata":[]},
        categoryName:"",
        actionsOnPlayer: false,
        audioUrl:null,
        controller:{},
        videoOptions: {
            autoplay: false,
            controls: true,
            nativeTextTracks: true,
            controlBar:{
                'pictureInPictureToggle': false,
            },
                    sources: []
                },
        };
    },
    components:{
        "cancel-icon": CancelIcon,
        VideoPlayer: VideoPlayer,
        NewCommentComp:NewCommentComp,
    },
    computed:{
        isTypeCatalog(){
            try {
                if('asset_type' in this.assetDetails){
                    return ["catalog"].includes(this.assetDetails.asset_type)
                }
            } catch (err) {
                console.error(`[isTypeCatalog][folder][Error while checking folderType-${err}]`)
            }
            return false
        },
        isAudioFile(){
            try {
                if('mime_type' in this.assetDetails){
                    return this.assetDetails.mime_type.startsWith("audio")
                }
                
            } catch (err) {
                console.error(`[isAudioFile][files][Error while checking filetype-${err}]`)
            }
            return false
        },
        isVideoFile(){
            try {
                if('mime_type' in this.assetDetails){
                    return this.assetDetails.mime_type.startsWith("video")
                }
            } catch (err) {
                console.error(`[isVideoFile][files][Error while checking filetype-${err}]`)
            }
            return false
        },
        isImageFile(){
            try {
                if('mime_type' in this.assetDetails){
                    return this.assetDetails.mime_type.startsWith("image")  ||  this.assetDetails.mime_type.startsWith("audio")   || this.assetDetails.mime_type.startsWith("doc")
                }
            } catch (err) {
                console.error(`[isImageFile][files][Error while checking filetype-${err}]`)
            }
            return false
        },
        selectedAssetInfo(){
            return {assetDetailsFromParent:this.assetDetails}
        },
        startUpInfo:{
            get(){
                return this.$store.state.startUpData.startUpDataDetails;
            }
        },
    },
    methods: {
        getColorBasedOnExpiry(locationInfo,storage){
            return Utils.getAWSStorageIconColorBasedOnExpiry(locationInfo,storage)
        },
        replaceByDefaultImage(e){
            e.target.onerror = null
            e.target.src = Utils.getNoThumbnailImg();
        },
        isActionEnabled(priv){
            return Utils.isPrivilegeEnabled(this.getLoggedInUserPrivilege(),priv)
        },
            selectedScreenType(){
                return "Tag Metadata";
            },
            playSubclipMarkinMarkout(markinMarkoutObj){
                this.controller.player.currentTime(markinMarkoutObj.markin);
                this.controller.player.play();
                try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
                this.controller.player.on('timeupdate',() =>{ 
                if(this.controller.player.currentTime() >= markinMarkoutObj.markout){
                    this.controller.player.pause();
                    this.$refs.tagMetadataWindow.activeSubclipPreview = '';
                    try{this.controller.player.off('timeupdate')}catch(e){console.log(e)}
                    }
                });
            },
            openSubclipWindow(){
                this.$emit("openSubclipWindow",this.assetDetails)
            },
            getFileName(fileInfo){
                return fileInfo.file_name?fileInfo.file_name:fileInfo.slug_name
            },
            getFilePath(fileInfo){
                if ("path" in fileInfo){
                    return fileInfo.path
                }else{
                    return this.getCategoryRoutefromId(fileInfo.category_id)
                }
            },
            setController(controller){
                    this.controller = controller
            },
            showActionsOnPlayer(){
                this.actionsOnPlayer = ! this.actionsOnPlayer;
            },
            maximisePlayer(){
                this.$emit("maximisePlayer");
            },
            closeMiniPlayer(){
                this.$emit("closeMiniPlayer")
            },
            getThumbnailPath(file){
                return Utils.getThumbnailPathfromFileInfo(file)
            },
            getLowresPath(file){
                return Utils.getLowresPathfromFileInfo(file)
            },
            getAudiowaveform(file){
                return Utils.getAudiowaveformFromFileInfo(file)
            },
            getFieldType(kId){
                let cMList = this.sCMList.filter(op=>op._id == kId);
                if(cMList.length > 0){
                    return cMList[0].type;
                }
                return "None"
            },
            getFieldName(kId){
                let cMList = this.sCMList.filter(op=>op._id == kId);
                if(cMList.length > 0){
                    return cMList[0].name;
                }
                return "None"
            },
            getUnique(array){
                var uniqueArray = [];
            
                // Loop through array values
                for(let i=0; i < array.length; i++){
                    if(uniqueArray.indexOf(array[i]) === -1) {
                        uniqueArray.push(array[i]);
                    }
                }
                return uniqueArray;
            },
            closeMetadataManager(){
                this.$emit("close");
            },
            rejectWithComments(commentText){
                let payload = {params:{_id:this.requestId},comment:commentText}
                this.updateWithAction("rejected")
                if(commentText.trim().length > 0){
                    if(this.isActionEnabled('tag-metadata-approver')){
                        this.addApproverComments(payload).then((data)=>{
                            if(!Utils.isAcceptedStatusCode(data.statusCode)){
                                this.$toast.error(data.message);
                            }
                        })
                    }else{
                        this.addRequestComments(payload).then((data)=>{
                            if(!Utils.isAcceptedStatusCode(data.statusCode)){
                                this.$toast.error(data.message);
                            }
                        })
                    }
                }
                this.openCommentComponent = false;
            },
            reject(){
                this.openCommentComponent = true;
            },
            approve(){
                this.updateWithAction("approved");
            },
            updateWithAction(actionType){
                let payload = {params:{_id:this.requestId}};
                payload.status = actionType;
                this.updateMetadataRequestorAsset(payload).then((data) => {
                    if(Utils.isAcceptedStatusCode(data.statusCode)){
                        this.$toast.success(data.message);
                        this.closeMetadataManager();
                    }else{
                        this.$toast.error(data.message);
                    }
                })
            },
            humaniseSize(bytes){
                let data = Utils.humanizeSize(bytes)
                return `${data["value"]} ${data["unit"]}`
            },
            selectCategoryforAnAsset(){
                this.$emit("selectCategoryFromBrowse");
                this.cancelMetadataDockFields()
            },
            getCategoryRoutefromId(){
            return this.route
            },
            getSelectedAssetDetails(){
                return JSON.parse(JSON.stringify(this.assetDetails))
            },
            setAssetInfo(info){
                this.requestInfo = {}
                this.requestInfo = info;
                this.newMetadataInfo = info.metadata_request;
                this.existingMetadataInfo = info.metadata_info[0]["existing_metadata"];
                this.assetDetails = info.file_info[0];
                if('mime_type' in this.assetDetails){
                    if (this.assetDetails.mime_type.startsWith("video")){
                        this.videoOptions.sources.push({
                                src:this.getLowresPath(this.assetDetails),
                                type: "video/mp4"
                            })
                    }else if (this.assetDetails.mime_type.startsWith("audio")){
                        this.audioUrl = this.getAudiowaveform(this.assetDetails)
                    }
                }
                this.isLoaded=true 
            },
            refreshFileInfoAndShowAsset(){                
                let payload = {params:{_id:this.requestId}}
                if(this.isActionEnabled('tag-metadata-approver')){
                    this.getApproverBasedRequestedInfoFromServer(payload).then((data) => {
                        if(Utils.isAcceptedStatusCode(data.statusCode)){
                            this.setAssetInfo(data["metadata_requests"]);
                        }
                    })
                }else{
                    this.getRequestedMetadataAssetInfoFromServer(payload).then((data) => {
                        if(Utils.isAcceptedStatusCode(data.statusCode)){
                            this.setAssetInfo(data["metadata_requests"]);
                        }
                    })
                }
            },
            handleFileUpdateNotification(notification){
                if(notification.message){
                    let path = notification.message.path
                    let parent_path = notification.message.parent_path
                    if (this.assetDetails.path == path && 'mime_type' in this.assetDetails){
                        if (this.assetDetails.mime_type.startsWith("video")){
                            Object.assign(this.assetDetails, notification.message)

                            this.videoOptions.sources = [{
                                    src:this.getLowresPath(notification.message),
                                    type: "video/mp4"
                                }]
                            if (  this.controller.player){
                                this.controller.restartPlayer(this.videoOptions.sources[0])
                            }
                        }else if (this.assetDetails.mime_type.startsWith("audio")){
                            this.audioUrl = this.getAudiowaveform(this.assetDetails)
                        }else if (this.assetDetails.mime_type.startsWith("image")){
                            Object.assign(this.assetDetails, notification.message)
                        }
                        console.log(`[handleFileUpdateNotification][AssetDetails][File(${path}) updated in path->${parent_path}]`)
                    }
                }
            },
            refreshStartData(keyName){
                if(keyName == "custom_metadatas" && Object.keys(this.getStartUpDataFromInCache()).includes("custom_metadatas")){
                    this.sCMList = this.getStartUpDataFromInCache()["custom_metadatas"];
                }else if(keyName == "screens" && Object.keys(this.getStartUpDataFromInCache()).includes("screens")){
                    let screens = this.getStartUpDataFromInCache()["screens"];
                    if(screens.length > 0){
                        let screensList = screens.filter((a)=>a.name == this.selectedScreenType());
                        if(screens.length > 0){
                            let screenDetails = screensList[0];
                            this.sScreenFields = JSON.parse(JSON.stringify(screenDetails));
                            this.tagMetadataScreenId = screenDetails._id;
                        }
                    }
                }
            },
            handleNotifications(notification){
                notification = notification.detail
                if(notification.message){
                    let entry_info = notification.message
                    if(notification.message_type == NotifierConstants.screenModifiedNotification){
                        if(this.tagMetadataScreenId == entry_info.screen_id){
                            setTimeout(()=>{
                                this.refreshStartData("screens");
                                this.refreshStartData("user_groups");
                            },100);
                        }
                    }else if([NotifierConstants.fieldCreatedNotification].includes(notification.message_type)){
                            setTimeout(()=>{
                                this.refreshStartData("screens");
                                this.refreshStartData("custom_metadatas");
                            }, 100);
                    }else if([NotifierConstants.fieldModifiedNotification,
                            NotifierConstants.fieldRemovedNotification].includes(notification.message_type)){
                            setTimeout(()=>{
                                this.refreshStartData("screens");
                                this.refreshStartData("custom_metadatas");
                            }, 100);
                    }else if(NotifierConstants.assetModifiedNotification){
                        for(let op of this.newMetadataInfo){
                            let newEntry = {
                                key_id:op.key_id
                            }
                            if(["description","tag"].includes(op.key_id)){
                                if(![undefined,null].includes(entry_info.metadata) && Object.keys(entry_info.metadata).length > 0){
                                    if(op.key_id == "tag"){
                                        if([undefined,null].includes(entry_info.metadata["tag_ids"]) || entry_info.metadata["tag_ids"].length <= 0){
                                                newEntry.value = []
                                        }else{
                                                newEntry.value = entry_info.metadata["tag_ids"]
                                                newEntry.tag_info = entry_info.tag_info;
                                        }
                                    }else if(op.key_id == "description"){
                                        if([undefined,null].includes(entry_info.metadata[op.key_id])){
                                                newEntry.value = "";
                                        }else{
                                            newEntry.value = entry_info.metadata[op.key_id];
                                        }
                                    }
                                }
                            }else if(["slug_name"].includes(op.key_id)){
                                if([undefined,null].includes(entry_info[op.key_id])){
                                    newEntry.value = "";
                                }else{
                                    newEntry.value = entry_info[op.key_id];
                                }
                            }else if(["catalog"].includes(op.key_id)){
                                if("parent_id_path" in entry_info){
                                    if([undefined,null].includes(entry_info.parent_id_path) || entry_info.parent_id_path.length <= 0){
                                        newEntry.value = [];
                                    }else{
                                        newEntry.value = entry_info.parent_id_path
                                        newEntry.catalog_info = [];
                                        for(let i of entry_info.parent_path){
                                            newEntry.catalog_info.push({
                                                catalog_id_path: i.id,
                                                catalog_name_path:i.value
                                            })
                                        }
                                    }
                                }
                            }else{
                                let cType = this.getFieldType(op.key_id);
                                if(["FREETEXT_MULTILINE","FREETEXT","INTEGER","PICKLIST","PICKLIST_MULTIVALUE","DATE","DATE_TIME"].includes(cType)){
                                    let eInfo = entry_info.custom_metadata.filter(d=>d.key_id == op.key_id)
                                    if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(cType)){
                                        newEntry.field_info = []
                                    }
                                    if(eInfo.length > 0){
                                        newEntry.value = eInfo[0].value
                                        if(["PICKLIST","PICKLIST_MULTIVALUE"].includes(cType)){
                                            for(let v of eInfo[0].value){
                                                let fInfo = entry_info.field_info.filter(p=>p.value_id == v);
                                                if(fInfo.length > 0){
                                                    newEntry.field_info.push(fInfo[0]);
                                                }
                                            }
                                        }
                                    }else{
                                        newEntry.value = [];
                                    }
                                }
                            }
                            let findIndex = this.existingMetadataInfo.findIndex(e=>e.key_id == op.key_id)
                            if(findIndex >= 0){
                                this.existingMetadataInfo.splice(findIndex, 1, newEntry)
                            }else{
                                let allEntries = this.existingMetadataInfo;
                                allEntries.push(newEntry);
                                this.existingMetadataInfo = allEntries;
                            }
                        }
                        // this.$toast.info("Requested asset metadata updated.")
                    }else if(NotifierConstants.assetRemovedCreatedNotification){
                        console.log("asset deldeted")
                    }
                    // else if(NotifierConstants.catalogModifiedNotification == notification.message_type){
                    //     if(this.selectedCatParentIdList.includes(notification.message._id)){
                    //         this.$toast.info("Selected catalog is updated by another user");
                    //         let catIndex = this.selectedCatParentIdPathList.findIndex(op=>op._id == notification.message._id)
                    //         this.selectedCatParentIdPathList[catIndex] = notification.message;
                    //     }
                    // }else if(NotifierConstants.catalogRemovedCreatedNotification == notification.message_type){
                    //         if(this.selectedCatParentIdList.includes(notification.message._id)){
                    //         this.$toast.info("Selected catalog is deleted by another user");
                    //         if(Utils.getCookieValue("context") == "catalogs-display"){
                    //             this.getCategoryRoutefromId(this.getSelectedCategoryInCategoryBrowse,false);
                    //         }else if(this.defaultCategory != undefined){
                    //             this.getCategoryRoutefromId(this.defaultCategory,true);
                    //         }else{
                    //             let payload = {};
                    //             payload.params = {catalog_id:JSON.stringify(Constants.rootCategory)}
                    //             this.getAllAssetsFromServer(payload).then((data)=>{
                    //             this.getCategoryRoutefromId(data["assets"][0],false)
                    //             });
                    //         }
                    //         }
                    // }else if(NotifierConstants.tagRemovedNotification == notification.message_type){
                    //         let temp = this.tagNamesList.filter(e => e._id == notification.message._id)
                    //         if (temp.length != 0){
                    //         this.tagNamesList = this.tagNamesList.filter(e => e._id != notification.message._id)
                    //         }
                    // }
                }
            },
            registerforWebsocketNotifications(){
                this.addWSEventListener({
                    eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
                    NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,
                    NotifierConstants.tagModifiedNotification,NotifierConstants.tagRemovedNotification,
                    NotifierConstants.screenModifiedNotification,
                    NotifierConstants.assetModifiedNotification,NotifierConstants.assetRemovedCreatedNotification],
                    callback:this.handleNotifications,
                    parent:"RequestedAssetMetadataInfo"})
                // this.addWSEventListener({eventname:NotifierConstants.fileModifiedNotification,
                //      callback:this.handleFileUpdateNotification,parent:"RequestedAssetMetadataInfo"})
            },
            unRegisterforWebsocketNotifications(){
                this.removeWSEventListener({
                        eventname:[NotifierConstants.fieldCreatedNotification, NotifierConstants.fieldModifiedNotification, NotifierConstants.fieldRemovedNotification,
                        NotifierConstants.catalogModifiedNotification,NotifierConstants.catalogRemovedCreatedNotification,
                        NotifierConstants.tagModifiedNotification,NotifierConstants.tagRemovedNotification,
                        NotifierConstants.screenModifiedNotification,
                        NotifierConstants.assetModifiedNotification,NotifierConstants.assetRemovedCreatedNotification],
                        callback:this.handleNotifications,
                        parent:"RequestedAssetMetadataInfo"})
                //this.removeWSEventListener({eventname:NotifierConstants.fileModifiedNotification, callback:this.handleFileUpdateNotification,parent:"RequestedAssetMetadataInfo"})
            },
            ...mapGetters("users",["getLoggedInUserPrivilege"]),
            ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
            ...mapActions("files", ["getFileInfoFromServer"]),
            ...mapActions("tags", ["getTagsOnAutocomplete"]),
            ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
            ...mapActions("assets", ["getAssetInfoFromServer"]),
            ...mapActions("assets",["getCategoryTreefromId"]),
            ...mapActions("metadataApprover",["getRequestedMetadataAssetInfoFromServer","getApproverBasedRequestedInfoFromServer",
                                                "addApproverComments", "addRequestComments","updateMetadataRequestorAsset"]),
    },
    beforeDestroy(){
        this.unRegisterforWebsocketNotifications()
    },
    created(){
        this.isLoaded=false;
        this.refreshStartData("custom_metadatas");
        this.refreshStartData("screens");
        this.refreshFileInfoAndShowAsset();
        this.registerforWebsocketNotifications();
    },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped lang="scss">
$header-background: #1a1a1a;
$border-color: 1px solid #4a4a4a;
$new-border-color:#237d21;
$background: #121212;
$background-color-on-hover: #141414;
$body-background-color: #141414;
$dull-text-color: #858585;
$options-text-color: #9c9c9c;
$icon-color-on-hover: #9c9c9c;
$text-color: #eee;
$table-row-border: none;
$table-border-color:1px solid #141414;
$active-blue: #007bff;
$input-field-bg-color: #121212;
$input-field-border-color: #202020;
$input-field-height:38px;
$button-height:38px;
$primary-background: #1a1e21;
$secondary-background-color: #15181B;
$secondary-border-color: 1px solid #2b2b2b;
$searchBar-border-color: 1px solid #202020;
$secondary-text-color: #9c9c9c;
$modal-border:1px solid #202020;
$modal-background: #121212;
$header-color:#9e9e9e;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#141414;
$scrollbar-thumb-on-hover-background:#555;
$input-field-padding:.375rem 10px;
$input-field-and-label-font-size:14px;
$danger-color: #dc3545 !important;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$updated-field-border-on-hover:#5a83af;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$breadcrumb-background:#181818;
$mutliselect-tag-bg-color:#0a0a0a;
$mutliselect-all-tags-bg-color:#161616;
$multiselect-option-highlight-bg-color:#242424;
$multiselect-tag-on-focus-or-hover-bg-color:#3D3D3D;
$learn-about-text-color:#e8912d;
$close-icon-bg-on-hover:#3a3a3a;
$svg-color:#9e9e9e;
$tags-background-color:#212121;
$tags-border-color:#2e2e2e;
$multiselect-tag-border-color:#292929;
$metadata-border-color:#303030;
$metadata-border-color-on-hover: #5a5a5a;
$metadata-field-bg-color: #181818;

.li-style-change{
  background: $metadata-field-bg-color;
}

.readonlyDiv{
    background: $secondary-background-color !important;
    border: none !important;
}

.readonly-field{
  color:$dull-text-color;
  font-size:12px;
}

.modal-dialog {
    width: 100vw;
    height: 100vh;
    max-width:100%;
    margin: 0;
    padding: 0;
  }
 
  .modal-content {
    height: auto;
    min-height: 100%;
    border: 0 none;
    border-radius: 0;
    box-shadow: none;
    background:$primary-background !important;
    border: $border-color;
    .modal-body{
      background: $primary-background;
      overflow:auto;
      height:300px;
      padding: 0px 0px 0px 0px;
      display:inline-flex;
      width:100%;
    }
  }

.modal {
  text-align: center;
  padding: 0!important;
  display:block;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.btn{
    font-size:14px !important;
    height:100%;
}

/* width */
::-webkit-scrollbar {
  width: 8px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #141414;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #333;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.border{
    border: $border-color !important;
}

.activeclass{
    color: $active-blue;
}
.activeNav,.activeNav:hover{
    background: $body-background-color !important;
    color: $active-blue !important;
}
.row{
  margin:-12px !important;
  margin-inline-start:0px !important;
}

.metadata-fields{
  background: $primary-background;
  border-inline-start: $secondary-border-color !important;
}


.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    align-items: unset;
    .modal-title{
      color:$text-color;
      padding:3px;
    }
}

.modal-header .close {
    margin: -1rem -19px -0rem auto !important;
}

ul{
    list-style-type: none;
}

.primary-btn-style{
    margin-top:1%;
    height:52px;
    display:inline-flex !important;
    flex-wrap: nowrap !important;
    justify-content: flex-start;
    button{
        height: 37px !important;
        border-radius: 5px;
    font-size:14px;
    float:inline-end;
    }
}
.activeTag{
    color: $active-blue !important;
}

.editIcon {
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 7%;
    top: 45%;
}

.aboutField{
  margin-inline-start: 9px;
  position: absolute;
    inset-inline-end: 1%;
    top: 45%;
}
.input-fields {
  border: none !important;
  min-width: 250Px;
  border-bottom: 1px solid $active-blue !important;
  padding-inline-start:5px;
  padding-top: 3px;
  height:38px;
}

.text-light{
  color: #b6b6b6 !important;
}

::v-deep{
.theme--light.v-text-field--solo>.v-input__control>.v-input__slot {
  background: #0a0a0a;
  border-bottom: 1px solid #3a3a3a;
}
.theme--light.v-text-field--filled:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover {
    background:$background;
}
.theme--light.v-chip {
    border-color:#3a3a3a !important;
    color:$text-color;
}

.theme--light.v-chip:not(.v-chip--active) {
    background: #121212;
}

.v-list-item--link:before{
  background-color:$background;
}
.vjs_video_3-dimensions, .video-js{
    height:350px !important;
    width:100% !important;
}
.video-js{
    // height:350px !important;
    height:100% !important;
    width:100% !important;
}
}
.secondary-btn-style:hover{
  text-decoration: underline;
}

.assets-details-in-metadata-manager{
    height:calc(100% - 46%);
    overflow:auto;
    // padding:0px 15px;
    margin-top:5px;
    ul{
        padding:0px !important;
        margin: 0px !important;
        height:100%;
        overflow: auto;
    }
}


// .input-fields {
//   border: none !important;
//   min-width: 250Px;
//   border: none !important;
//   border-bottom: 1px solid $active-blue !important;
// }

ul{
    list-style-type: none;
    padding: 0px;
    margin-inline-start:10px;
    li{
        display:inline-flex;
        width: 100%;
        padding:7px;
        .key-style{
            color:$dull-text-color;
            width:30%;
            text-align: end;
        }
        .value-style{
            color: #b6b6b6;
            width: 70%;
            text-align: start;
            padding-inline-start:5px !important
        }
    }
}


.selected-thumbnail-display{
    width: 50%;
    display: inline-block;
    max-width: 33%;
    img{
        height:100%;
        // width:100%;
    }
    svg{
        float: inline-end;
        margin-top:5px;
    }
}


.audio-player{
    position: absolute;
    bottom: 0px;
    width: 100%;
    height: 26px;
    inset-inline-start:0px;
}


.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}

input:focus,select:focus,textarea:focus,.multiselect__input:focus,.mx-input:focus{
    outline: none;
    --saf-0: rgba(var(--sk_highlight,18,100,163),1);
    box-shadow: 0 0 0 1px var(--saf-0),0 0 0 5px #00254E;
    border-radius: 4px;
    border-color: transparent;
    -webkit-appearance: none;
}

.tags-display-ul .show-tags-delete{
  visibility:hidden;
}

.tags-display-ul li:hover .show-tags-delete{
  visibility: visible;
}

.tags-display-ul{
  margin-inline-start:0px;
    list-style-type: none;
    display: inline-flex;
    flex-wrap: wrap;
    margin-top: 0;
    width: 100%;
    justify-content: start;
    overflow: auto;
  label{
    padding: 0px 5px;
  }
}

.metadata-dock-ul li .aboutField {
  visibility: hidden;
}

.metadata-dock-ul li:hover .aboutField {
  visibility: visible;
}

.metadata-dock-ul {
  list-style-type: none;
  padding: 0px;
  user-select: none; 
  position:relative;
  margin-inline-start:0px;
  width:100%;
  background:$primary-background;
  overflow:auto;
//   .fields-styles{
//       margin-bottom:8px;
//     li{
//       margin-bottom:1px;
//     }
//   }
  li {
    //padding: 7px;
    //margin: 4px 8px;
    width: 99%;
    position: relative;
    .existing-metadata{
        width: 49%;
        display: inline-block;
        border: $border-color;
        border-radius: 4px;
        background:$primary-background;
    }
    .desc-div{
        max-height: 170px;
    }
    .added-value{
        border-inline-start:5px solid  $new-border-color;
        .view-tags {
            background: transparent !important;
        }
    }
    .cleared-value{
        border-inline-start:5px solid #a10505 ;
        .view-tags {
            background: transparent !important;
        }
    }
    .updated-value{
        color: #8aa1ad;
        border-inline-start:5px solid  $updated-field-border-on-hover;
        .view-tags {
            background: transparent !important;
        }
    }
    .key-style {
      color: $dull-text-color;
      width: auto;
      text-align: start;
      font-size: 14px;
      padding-inline-start: 5px;
      padding-inline-end: 5px;
      margin-top: 3px;
    }
    .value-style {
      color: $text-color;
      width: 97%;
      text-align: start;
      padding-top: 3px;
      padding-bottom: 3px;
      padding-inline-end: 5px;
      padding-inline-start: 0px;
      .slug-ellipsis {
        white-space: nowrap;
        max-width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .desc-ellipsis{
            max-height:135px;
            height: 100px;
            width: 97%;
            max-width: 100%;
            color: $text-color;
            padding-inline-start: 5px;
            padding-top: 2px;
      }
      .save-cancel-icon{
        position:relative;
        top:10px;
        inset-inline-start:5px;
        color:#fff;
      }
      .browse-icon{
        color:#636363 !important;
      }
    }
  }
//   li:hover{
//     border:1px solid $metadata-border-color-on-hover
//   }
}

.metadata-dock-ul li .editIcon {
  /* visibility: hidden; */
  opacity: 0;
}

.metadata-dock-ul li:hover .editIcon,.metadata-dock-ul li:focus-within .editIcon {
 /*  visibility: visible; */
  opacity:1;
}

.metadata-dock-ul{
    // height:100%;
    display:inline-block;
    //padding-bottom: 10px;
}

.metadata-dock-ul li:focus {
  border: 1px solid $active-blue !important;
}

.align-texts{
  li{
    .value-style{
      padding-inline-start: 5px !important;
    }
  }
}

.view-tags {
    font-size: 12px !important;
    height: 28px !important;
    display: inline-flex !important;
    margin: 2px !important;
    border: 1px solid $tags-border-color !important;
    border-radius: 15px !important;
    min-width: 50px !important;
    padding: 0px 5px !important;
    text-align: center;
    width: auto !important;
    justify-content: center;
    padding-top: 4px !important;
    background: $tags-background-color !important;
  span, div {
    padding: 0px 8px !important;
    margin-inline-start: 0px !important;
    font-size: 12px !important;
    border-radius: 15px !important;
    position: relative !important;
    top: 1px !important;
  }
}

.view-tags:hover {
  border: $border-color !important;
}

</style>
